import random from "lodash/random";
import sum from "lodash/sum";

const rollAbility = () => random(1, 4) - random(1, 4);

export const getAbilities = () => {
  return {
    body: rollAbility(),
    dexterity: rollAbility(),
    savvy: rollAbility(),
    tech: rollAbility(),
  };
};

export const sumOfAbilities = (abilities) => sum(Object.values(abilities));
